<template>
    <div>
        <div class="table-wrapper">
            <table id="copy_media_table" class="cic-table">
                <thead>
                    <tr>
                        <th style="width: 40px"></th>
                        <th>{{ $t('Media') }}</th>
                        <th style="width: 80px">{{ $t('Media Type') }}</th>
                        <th style="width: 40px; text-align: center">{{ $t('Select') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in media">
                        <td :class="'media-icon media-icon-' + row.type"></td>
                        <td>{{ row.name }}</td>
                        <td>{{ $t('MEDIA_TYPE_' + row.type) }}</td>
                        <td><CicCheckbox :value="selected.includes(row.id)" @input="handleSelected(row.id)" /></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="cic-footer">
            <CicButton id="copy" @click="$emit('change', selected)">{{ $t('Copy') }}</CicButton>
        </div>
    </div>
</template>

<script>
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicButton from '@/components/CicButton';

    export default {
        name: 'CopyMedia',
        components: {
            CicButton,
            CicCheckbox,
        },
        props: {
            media: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
        data() {
            return {
                selected: [],
            };
        },
        methods: {
            handleSelected(itemId) {
                if (this.selected.indexOf(itemId) !== -1) {
                    this.selected.splice(this.selected.indexOf(itemId), 1);
                } else {
                    this.selected.push(itemId);
                }
            },
        },
    };
</script>
